var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-select",
    _vm._g(
      _vm._b(
        {
          class: _vm.$style.select,
          attrs: {
            placeholder: _vm.placeholder,
            attach: _vm.isMobilePlatform,
            "append-icon": "keyboard_arrow_down",
            color: "#38AA3F"
          },
          on: { change: _vm.dataChanged }
        },
        "v-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SelectField.vue?vue&type=template&id=1d41985e&
// module id = null
// module chunks = 